import { render, staticRenderFns } from "./DialogoFormulario.vue?vue&type=template&id=7f5a123c&"
import script from "./DialogoFormulario.vue?vue&type=script&lang=js&"
export * from "./DialogoFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports